export default [
  {
    label: 'メールアドレス',
    key: 'search_email',
  },
]
